var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSinglechoice = function SvgSinglechoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.5 51"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".singlechoice_svg__abc{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "singlechoice_svg__bdfdad9d-e824-4487-8add-7375d0eb0bf9",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "singlechoice_svg__edb4e9ab-ce1d-4d0f-a003-2d861bcfe2b4",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.5H58",
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 25.5,
    r: 5,
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 25.5H58",
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 45.5,
    r: 5,
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 45.5H58",
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 25.5,
    r: 3,
    className: "singlechoice_svg__abc"
  })))));
};
export default SvgSinglechoice;